import React from "react";
import Flyout from "./Flyout";
import ToolButton from "./ToolButton";
import { SHAPE_LIST } from "./boardTools";

/** Which shape the shape tool draws (Figma 205:396). */
const ShapePicker = ({ isOpen, value, onChange, isDark, top, side }) => (
  <Flyout label="Shapes" isOpen={isOpen} isDark={isDark} top={top} side={side}>
    {SHAPE_LIST.map((shape) => (
      <ToolButton
        key={shape.id}
        icon={shape.icon}
        label={shape.label}
        isActive={shape.id === value}
        isDark={isDark}
        boxSize="38px"
        onClick={() => onChange(shape.id)}
      />
    ))}
  </Flyout>
);

export default ShapePicker;
